import { useState, forwardRef } from 'react'

export interface CheckboxProps {
  className?: string;
  id?: string;
  checked?: boolean;
  children?: string | React.ReactNode;
  indeterminate?: boolean;
  handleChecked?: React.ChangeEventHandler<HTMLInputElement>
}

const Checkbox: React.ForwardRefRenderFunction<HTMLInputElement, CheckboxProps> = ({
  className,
  id,
  children,
  checked,
  indeterminate,
  handleChecked,
  ...restProps
}, ref) => {
  const [_checked, setChecked] = useState(false)
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
    handleChecked?.(event)
  }
  return (
    <label className={`flex items-center cursor-pointer ${className}`} id={id} >
      <input className="sr-only"
        type="checkbox"
        ref={ref}
        onChange={onChange}
        checked={checked}
        {...restProps}
      />

      <div className={`w-4 h-4 border rounded-xs transition-all duration-200
        ${checked || _checked || indeterminate ? 'border-sprimary-600 bg-sprimary-600 ring-2 ring-offset-2 ring-sprimary-600' : 'border-gray-500 bg-white'}
      `}>
        {
          (checked || _checked) && <svg viewBox="0 0 24 24" fill="none" stroke="white" >
            <polyline points="20 6 9 17 4 12" strokeWidth="3" />
          </svg>
        }
        {
          indeterminate && <svg viewBox="0 0 24 24" fill="none" stroke="white" >
            <polyline points="20 12 4 12" strokeWidth="4" />
          </svg>
        }
      </div>
      {
        children
      }
    </label>
  )
}

export default forwardRef<HTMLInputElement, CheckboxProps>(Checkbox)